import type { AccountKey } from 'owa-client-types';
import type { BizChatCompositeKey, WindowKey, MainWindowKey } from 'owa-bizchat-types';

interface SessionInfo {
    sessionId: string;
    timestamp: number;
    accountKey: AccountKey;
    windowKey: WindowKey;
}

const sessionIdByKey: Map<BizChatCompositeKey, SessionInfo> = new Map();

function getSessionKey(accountKey: AccountKey, windowKey: WindowKey): BizChatCompositeKey {
    return `${accountKey}_${windowKey}`;
}

export function setBizChatSessionId(
    accountKey: AccountKey,
    windowKey: WindowKey,
    sessionId: string
): void {
    const key = getSessionKey(accountKey, windowKey);
    const sessionInfo: SessionInfo = {
        sessionId,
        timestamp: Date.now(),
        accountKey,
        windowKey,
    };
    sessionIdByKey.set(key, sessionInfo);
}

export function getBizChatSessionId(
    accountKey: AccountKey,
    windowKey: WindowKey
): string | undefined {
    const key = getSessionKey(accountKey, windowKey);
    const sessionInfo = sessionIdByKey.get(key);
    return sessionInfo ? sessionInfo.sessionId : undefined;
}

export function removeBizChatSessionId(accountKey: AccountKey, windowKey: WindowKey): void {
    const key = getSessionKey(accountKey, windowKey);
    sessionIdByKey.delete(key);
}

export function clearAllMainWindowBizChatSessionIds(): void {
    for (const [compositeKey, sessionInfo] of sessionIdByKey.entries()) {
        if (isMainWindowKey(sessionInfo.windowKey)) {
            sessionIdByKey.delete(compositeKey);
        }
    }
}

export function getActiveBizChatSessionCounts(): {
    mainCount: number;
    popoutCount: number;
} {
    let mainCount = 0;
    let popoutCount = 0;

    for (const sessionInfo of sessionIdByKey.values()) {
        if (isMainWindowKey(sessionInfo.windowKey)) {
            mainCount++;
        } else {
            popoutCount++;
        }
    }

    return { mainCount, popoutCount };
}

function isMainWindowKey(windowKey: WindowKey): windowKey is MainWindowKey {
    return windowKey === 'SidePane' || windowKey === 'Immersive';
}
